exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: colmo) {\n.left {\n    padding-left: 0.16rem;\n}\n.middle-title {\n    font-family: PingFangSC-Regular;\n    font-weight: 400;\n}\n.icon-text {\n    padding-left: 0.26667rem;\n    font-size: 0.42667rem;\n    color: rgba(255, 255, 255, 0.4);\n}\n}", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-minibar/colmo.css"],"names":[],"mappings":";AAAA;AACE;IACE,sBAAmB;CACpB;AACD;IACE,gCAAgC;IAChC,iBAAiB;CAClB;AACD;IACE,yBAAmB;IACnB,sBAAgB;IAChB,gCAAgC;CACjC;CACF","file":"colmo.css","sourcesContent":["@media screen and (weex-theme: colmo) {\n  .left {\n    padding-left: 12px;\n  }\n  .middle-title {\n    font-family: PingFangSC-Regular;\n    font-weight: 400;\n  }\n  .icon-text {\n    padding-left: 20px;\n    font-size: 32px;\n    color: rgba(255, 255, 255, 0.4);\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f607d5d2","scoped":false,"hasInlineConfig":false}!./packages/dof-minibar/colmo.css
// module id = 271
// module chunks = 0 1